import { forwardRef, InputHTMLAttributes } from "react";
import styles from "./Checkbox.module.scss";

export interface CheckboxProps
    extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
    label?: string;
    error?: string;
    onCheckedChange?: (checked: boolean) => void;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
    (
        {
            className,
            label,
            error,
            checked,
            defaultChecked,
            onChange,
            onCheckedChange,
            disabled,
            id,
            ...props
        },
        ref
    ) => {
        // Handle both native onChange and custom onCheckedChange
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            onChange?.(e);
            onCheckedChange?.(e.target.checked);
        };

        const inputId = id || `checkbox-${Math.random().toString(36).substr(2, 9)}`;

        return (
            <div className={`${styles.wrapper} ${className || ""}`}>
                <label className={styles.container} htmlFor={inputId}>
                    <input
                        ref={ref}
                        type="checkbox"
                        id={inputId}
                        className={styles.input}
                        checked={checked}
                        defaultChecked={defaultChecked}
                        onChange={handleChange}
                        disabled={disabled}
                        aria-invalid={!!error}
                        {...props}
                    />
                    <span className={styles.checkmark} aria-hidden="true" />
                    {label && <span className={styles.label}>{label}</span>}
                </label>
                {error && (
                    <p className={styles.error} role="alert">
                        {error}
                    </p>
                )}
            </div>
        );
    }
);

Checkbox.displayName = "Checkbox";
